import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';
import { IValueViewModel } from '../../models';

class WtPopoverContoller implements angular.IController {
    item: IValueViewModel;
    placement: string;
    popoverClass: string;
    template: string;

    private _watch: () => void;
    
    static $inject = ['$scope'];

    constructor(private _$scope) { }

    $onInit() {
        // TODO remove this mechanism and implement $onChanges
        this._watch = this._$scope.$watch(() => this.item, (newValue) => {
            if (newValue && newValue.groupList) {
                newValue.groupNames = newValue.groupList.map(t => t.uniqueName).join(', ');
            }
        });
    }

    $onDestroy() {
        this._watch();
    }
}

export const WtPopoverDirective: DirectiveDefinition = {
    directiveId: 'wtPopover',
    template: require('./popover.directive.html'),
    restrict: 'A',
    scope: {
        item: '<',
        placement: '@?',
        popoverClass: '@?',
        template: '@'
    },
    controller: WtPopoverContoller,
    bindToController: true,
    controllerAs: 'vm',
    transclude: true
};